import {Component, Input, OnInit} from '@angular/core';
import {BlockStatementAbstractComponent} from '../../blocks/block-statement-abstract.component';

@Component({
    selector: 'core-toggle-figures',
    templateUrl: './toggle-figures.component.html',
    standalone: false
})
export class ToggleFiguresComponent extends BlockStatementAbstractComponent implements OnInit {
    isFiguresHide?: boolean;
    override isPrintPDFRoute!: boolean;
    @Input() isFloatingToggle!: boolean;
    isMobileStyles?: boolean;

    override ngOnInit(): void {
        this.subscriptions.push(this.trsService.getFiguresToggleState$().subscribe((value: boolean) => {
            this.isFiguresHide = value;
        }));

        this.breakpoint.observe([
            '(max-width: 475px)'
        ]).subscribe(result => {
            this.isMobileStyles = result.matches;
        });
    }

    setState(state: string): void {
        if (state === 'hide') {
            this.trsService.setFiguresToggleState(true);
        } else if (state === 'show') {
            this.trsService.setFiguresToggleState(false);
        }
    }

}
